const enum DatePickerValidationEnum {
  ALL_DATES = 'all',
  ONLY_TODAY = 'today',
  ONLY_FUTURE_DATES = 'next',
  ONLY_PAST_DATES = 'past',
}

export { DatePickerValidationEnum };
